import React, { useEffect, useState } from 'react';
import { supabaseUrl, supabaseKey } from '../config.ts';
import { createClient } from '@supabase/supabase-js';
import { Link } from "react-router-dom";

const Service = () => {
    // Initialize Supabase client
const supabase = createClient(supabaseUrl, supabaseKey);
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchServices = async () => {
            setLoading(true);
            const { data, error } = await supabase
                .from('services')
                .select('*')
                .order('created_at', { ascending: false });
            if (error) {
                setServices([]);
            } else {
                setServices(data || []);
            }
            setLoading(false);
        };
        fetchServices();
    }, []);

    return (
        <>
            {/* Header Start */}
            <div className="container-fluid bg-breadcrumb">
                <ul className="breadcrumb-animation">
                    <li />
                    <li />
                    <li />
                    <li />
                    <li />
                    <li />
                    <li />
                    <li />
                    <li />
                    <li />
                </ul>
                <div className="container text-center py-5" style={{ maxWidth: 900 }}>
                    <h3 className="display-3 mb-4 wow fadeInDown" data-wow-delay="0.1s">
                        Our Services
                    </h3>
                    <ol
                        className="breadcrumb justify-content-center mb-0 wow fadeInDown"
                        data-wow-delay="0.3s"
                    >
                        <li className="breadcrumb-item">
                            <a href="/">Home</a>
                        </li>
                        <li className="breadcrumb-item active text-primary">Service</li>
                    </ol>
                </div>
            </div>
            {/* Header End */}
            {/* Service Start */}
            <div className="container-fluid service py-5 bg-light">
                <div className="container py-5">
                    <div
                        className="text-center mx-auto mb-5 wow fadeInUp"
                        data-wow-delay="0.1s"
                        style={{ maxWidth: 900 }}
                    >
                        <span className="text-primary text-uppercase fw-bold">
                            Our Services
                        </span>
                        <h1 className="display-4 mb-4 mt-2">What We Can Do For You</h1>
                        <p className="lead mb-0">
                            We specialize in turning your construction dreams into reality. From
                            initial planning to project completion, our team provides
                            comprehensive solutions tailored to your needs.
                        </p>
                    </div>
                    {loading ? (
                        <div className="text-center py-5">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        <div className="row g-4 justify-content-center">
                            {services.map((service, idx) => (
                                <div
                                    className="col-md-6 col-lg-4 col-xl-3 wow fadeInUp"
                                    data-wow-delay={`${0.1 + (idx % 4) * 0.2}s`}
                                    key={service.id}
                                >
                                    <div className="service-item h-100 position-relative overflow-hidden shadow-sm rounded-4 hover-scale">
                                        <img
                                            src={service.image || "./img/services/default.png"}
                                            alt={service.title}
                                            className="img-fluid w-100 service-img"
                                        />
                                        <div className="service-content p-4 bg-white">
                                            <h4 className="fw-bold mb-3">{service.title}</h4>
                                            <Link
                                                to={`/serviceDetails/${service.id}`}
                                                className="btn btn-primary rounded-pill py-2 px-4 stretched-link"
                                            >
                                                View Details
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
            {/* Service End */}
            {/* FAQ Start */}
            <div className="container-fluid FAQ bg-light overflow-hidden py-5">
                <div className="container py-5">
                    <div className="row g-5 align-items-center">
                        <div className="col-lg-8 wow fadeInLeft" data-wow-delay="0.1s">
                            <div className="accordion custom-accordion" id="accordionExample">
                                <div className="accordion-item border-0 mb-4 shadow-sm">
                                    <h2 className="accordion-header" id="headingOne">
                                        <button
                                            className="accordion-button rounded-top fw-bold"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapseOne"
                                            aria-expanded="true"
                                            aria-controls="collapseTOne"
                                        >
                                            Why Choose Our Construction Services?
                                        </button>
                                    </h2>
                                    <div
                                        id="collapseOne"
                                        className="accordion-collapse collapse show"
                                        aria-labelledby="headingOne"
                                        data-bs-parent="#accordionExample"
                                    >
                                        <div className="accordion-body my-2">
                                            <h5 className="text-primary mb-3">
                                                Excellence in Construction Solutions
                                            </h5>
                                            <p>
                                                With over two decades of experience in the construction
                                                industry, we deliver exceptional quality and innovative
                                                solutions for all your building needs. Our team of experts
                                                combines technical expertise with creative problem-solving
                                                to ensure your project's success.
                                            </p>
                                            <p>
                                                We pride ourselves on our commitment to transparency, timely
                                                delivery, and cost-effective solutions that exceed client
                                                expectations.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item border-0 mb-4 shadow-sm">
                                    <h2 className="accordion-header" id="headingTwo">
                                        <button
                                            className="accordion-button collapsed rounded-top fw-bold"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapseTwo"
                                            aria-expanded="false"
                                            aria-controls="collapseTwo"
                                        >
                                            What is Our Pricing Structure?
                                        </button>
                                    </h2>
                                    <div
                                        id="collapseTwo"
                                        className="accordion-collapse collapse"
                                        aria-labelledby="headingTwo"
                                        data-bs-parent="#accordionExample"
                                    >
                                        <div className="accordion-body my-2">
                                            <h5 className="text-primary mb-3">
                                                Transparent and Competitive Pricing
                                            </h5>
                                            <p>
                                                We believe in complete transparency in our pricing
                                                structure. Our quotes include detailed breakdowns of all
                                                costs involved in your project. We work with you to create
                                                flexible payment plans that suit your budget while
                                                maintaining the highest quality standards.
                                            </p>
                                            <p>
                                                Our value-based pricing ensures you receive the best return
                                                on your investment, with no hidden costs or unexpected
                                                charges.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item border-0 shadow-sm">
                                    <h2 className="accordion-header" id="headingThree">
                                        <button
                                            className="accordion-button collapsed rounded-top fw-bold"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapseThree"
                                            aria-expanded="false"
                                            aria-controls="collapseThree"
                                        >
                                            How Do We Ensure Project Success?
                                        </button>
                                    </h2>
                                    <div
                                        id="collapseThree"
                                        className="accordion-collapse collapse"
                                        aria-labelledby="headingThree"
                                        data-bs-parent="#accordionExample"
                                    >
                                        <div className="accordion-body my-2">
                                            <h5 className="text-primary mb-3">
                                                Comprehensive Project Management
                                            </h5>
                                            <p>
                                                Our proven project management methodology ensures seamless
                                                execution from conception to completion. We employ advanced
                                                planning tools, regular progress monitoring, and effective
                                                communication channels to keep your project on track.
                                            </p>
                                            <p>
                                                Our dedicated team of professionals works collaboratively to
                                                address challenges proactively, ensuring timely completion
                                                while maintaining the highest quality standards.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 wow fadeInRight" data-wow-delay="0.3s">
                            <div className="FAQ-img RotateMoveRight rounded-2 shadow-lg overflow-hidden">
                                <img
                                    src="../../assets/img/services.png"
                                    className="img-fluid w-100 hover-scale"
                                    alt="Construction Services"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* FAQ End */}
        </>

    )
}

export default Service